<template>
  <div>
    <v-navigation-drawer
      color="#F5F5F5"
      v-model="drawer"
      app
      clipped
    >
      <v-list>
          <v-list-item
            :disabled="load"
            @click="rotas(item)"
            v-for="(item, index) in sideBar"
            :key="index"
            link
          >
            <v-list-item-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.nome}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        <v-list-group
          :disabled="load"
          v-for="item in sideBarSub"
          :key="item.nome"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.nome"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
          :disabled="load"
            v-for="subItem in item.subItem"
            :key="subItem.op"
            @click="rotas(subItem)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="subItem.nome"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!--<v-list :disabled="load">
        <v-list-item-group color="primary">
          <v-list-item
            @click="rotas(item)"
            v-for="(item, index) in sideBar"
            :key="index"
            link
          >
            <v-list-item-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{item.nome}}</v-list-item-title>
            </v-list-item-content>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.nome"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="subItem in item.subItem"
              :key="subItem.nome"
              @click="rotas(subItem)"
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.nome"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </v-list-item-group>
      </v-list>-->
    </v-navigation-drawer>
    <v-app-bar
      elevation="1"
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Dashboard</v-toolbar-title>
      <v-progress-linear
        :active="load"
        :indeterminate="load"
        absolute
        bottom
      ></v-progress-linear>
      <v-spacer></v-spacer>
      <v-btn
        icon
        @click="logout"
      >
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import ruleservices from './../services/ruleservice'
import { EventBus } from './../main'
import {
  removeToken
} from '../store/auth'

export default {
  components: {},
  computed: {},
  data () {
    return {
      nameApp: '',
      mini: false,
      sideBarSub: [],
      drawer: null,
      load: false,
      sideBar: [],
      primary: false,
      dialog: false,
      login: true,
      user: {},
      items: [],
      mItem: '',
      colors: {},
      action: true
    }
  },
  props: {},
  mounted () {
    this.carregarOpcoes()
    EventBus.$on('loadStop', this.computerDrawer)
  },
  methods: {
    rotas: function (data) {
      console.log(data)
      switch (data.op) {
        case 1:
          this.$router.push('/')
          EventBus.$emit('filtro', data.filtro)
          break
        case 2:
          this.$router.push('/estatisticas')
          break
        case 3:
          this.$router.push('/faturamento')
          EventBus.$emit('filtro', data.filtro)
          break
        case 4:
          this.$router.push('/ajustesFaturamento')
          break
        case 5:
          this.$router.push('/ajustes')
          // EventBus.$emit('filtro', data.filtro)
          break
        case 6:
          this.$router.push('/pesquisas')
          break
        default:
          break
      }
    },
    logout: function () {
      removeToken()
      // this.$cookies.remove('user')
      this.$router.push('/login')
    },
    carregarOpcoes: function () {
      ruleservices.drawer().then(r => {
        if (r.status === 200) {
          var items = r.data.msg.drawer
          for (let i = 0; i < items.length; i++) {
            const e = items[i]
            if (e.subItem != null && e.subItem.length > 0) {
              this.sideBarSub.push(e)
            } else {
              this.sideBar.push(e)
            }
          }
        }
      })
    },
    computerDrawer (i) {
      this.load = this.load + i
      if (this.load === 0) {
        EventBus.$emit('load', false)
      } else {
        EventBus.$emit('load', true)
      }
    }
  }
}
</script>

<style scoped>
</style>
